import React from 'react';
import { PatientRedirect } from '@/components/PatientRedirect/PatientRedirect';

export const PatientRedirectPage = () => {
  return <PatientRedirect />;
};
